
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 904 1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M807.153 722.824c-60.235-36.141-132.518-30.118-186.729 12.047L325.271 548.142c6.024-24.094 6.024-42.165 0-66.259l295.153-186.729c54.212 42.165 126.494 48.188 186.729 12.047 78.306-48.188 102.4-150.588 54.212-228.894s-150.588-102.4-228.894-54.212c-60.235 36.141-84.329 108.424-72.282 174.682L265.036 385.506c-54.212-42.165-126.494-48.188-186.729-12.047-78.306 48.188-102.4 150.588-54.212 228.894s150.588 102.4 228.894 54.212c6.024-6.024 12.047-6.024 12.047-12.047l295.153 186.729c-12.047 66.259 12.047 132.518 72.282 174.682 78.306 48.188 180.706 24.094 228.894-54.212 48.188-84.329 24.094-180.706-54.212-228.894z","fill":"currentColor"}})])
          )
        }
      }
    